import Layout from '@/components/feature/Layout';
import ButtonLink from '@/components/base/ButtonLink';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta('Page not found | MATERA', 'The page you were looking for does not exist or has moved.');
  return (
    <Layout>
      <section className="min-h-[80vh] pt-32 pb-20 bg-background-50 flex items-center">
        <div className="shell">
          <p className="text-[11px] uppercase tracking-[0.22em] text-accent-600">Error 404</p>
          <h1 className="display mt-6 text-[clamp(2.4rem,8vw,7rem)]">Nothing on this wall.</h1>
          <p className="mt-6 text-[15px] text-foreground-700 max-w-md">The page you were looking for doesn&apos;t exist or has moved.</p>
          <div className="mt-10"><ButtonLink to="/">Back to home</ButtonLink></div>
        </div>
      </section>
    </Layout>
  );
}